import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

const initialState = {
  user: null,
};

export const UserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    signIn: (state, { payload }) => {
      localStorage.setItem("token", payload.token);
      const decodedToken = jwtDecode(payload.token);
      state.user = {
        ...decodedToken,
      };
      console.log("state.user", state?.user)
    },
    signOut: (state) => {
      localStorage.removeItem("token");
      state.user = null;
    },
  },
});

export const { signOut, signIn } = UserSlice.actions;

export default UserSlice.reducer;
